import { useState } from 'react'

import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import { Form, Formik } from 'formik'

const UpdateForm = (props) => {
  const { concept, formRef, tipoOblea, setSelectedConcept } = props

  const [data, setData] = useState({
    oblea_tipo: concept ? concept.oblea_tipo : null,
    oblea_rudac: concept ? concept.oblea_rudac : '',
    id: concept ? concept.id : '',
    familia: concept ? concept.familia : null,
    old_id: concept ? concept.old_id : null,
  })

  const FormEdit = (values, setFieldValue) => {
    return [
      {
        class: 'textfield',
        label: 'Nombre',
        name: 'oblea_rudac',
        value: values.oblea_rudac,
        disabled: true,
        sm: 12,
        xs: 12,
      },
      {
        label: 'Tipo de oblea',
        name: 'oblea_tipo',
        options: tipoOblea,
        onChange: (oblea_tipo) => {
          setFieldValue('oblea_tipo', oblea_tipo.id)
          setData({
            ...data,
            oblea_tipo: oblea_tipo.id,
          })
          setSelectedConcept({
            ...data,
            oblea_tipo: oblea_tipo.id,
          })
        },
        value: data.oblea_tipo,
        optionLabel: `options["tipo"]`,
        optionValue: 'id',
        sm: 12,
        xs: 12,
        class: 'autocomplete',
      },
    ]
  }

  const onSubmit = (data) => {
    props.onSubmit(data)
  }

  return (
    <Formik onSubmit={onSubmit} initialValues={data}>
      {({ setFieldValue, values }) => (
        <Form>
          <InputsWithValidate
            fields={FormEdit(values, setFieldValue)}
            spacing={2}
            setFieldValue={setFieldValue}
            isSubmitting={false}
          />

          <button style={{ display: 'none' }} type="submit" ref={formRef} />
        </Form>
      )}
    </Formik>
  )
}

export default UpdateForm
